<template>
    <div class="x_box A4">
        <div class="x_body">
            <h4 class="text-center font-m">{{$t('report_out_of_stock')}}</h4><br>
            <table class="table table-bordered table-striped table-sm no-bor">
                <thead>
                <tr>
                    <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                    <th>{{ $t('code') }}</th>
                    <th>{{ $t('name') }}</th>
                    <th>{{ $t('vendor') }}</th>
                    <th class="text-right">{{ $t('qty_alert') }}</th>
                    <th class="text-right">{{ $t('ending_stock') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(ret, index) in list" :key="index">
                    <td class="text-center">{{index+1}}</td>
                    <td>{{ ret.Num }}</td>
                    <td>{{ ret.Name }}</td>       
                    <td>{{ ret.VendorName }}</td>       
                    <td class="text-right">{{ ret.AlertQty }}</td>
                    <td class="text-right">{{$number(ret.EndingQty, '0,0.[00]')}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                query:{
                    VendorId: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25
                },
                list: [],
            }
        },
        created: function(){
            let vendor = this.$route.query.vendor;
            if(vendor != undefined){
                this.query.VendorId = vendor;
            }
            this.toList();
        },
        methods: {
            toList(){
                let loading = this.$loading.show();
                this.$api().post('report/item/outofstock', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Json.OutOfStock;
                    }
                }).finally(function() { loading.hide(); });
            },
        }
    }
</script>
